import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/list-ordered.vue
var o = {
	name: "DtIconListOrdered",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--list-ordered"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "List Ordered",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M1 2a.5.5 0 0 1 .5-.5h1A.5.5 0 0 1 3 2v2.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H2v-2h-.5A.5.5 0 0 1 1 2Zm3.701 1.5a.5.5 0 0 1 .5-.5h5.3a.5.5 0 1 1 0 1H5.2a.5.5 0 0 1-.5-.5Zm-2.2 4a.5.5 0 0 0-.476.345.5.5 0 1 1-.951-.31A1.5 1.5 0 0 1 4 8c0 .478-.252.803-.523 1.016-.21.165-.47.293-.66.386a11.515 11.515 0 0 0-.194.098h1.002a.5.5 0 0 1 0 1H1.5a.5.5 0 0 1-.447-.724c.14-.28.294-.517.5-.723.206-.207.443-.36.724-.5l.123-.061c.193-.096.34-.168.458-.261S3 8.074 3 8a.5.5 0 0 0-.5-.5Zm2.2 1a.5.5 0 0 1 .5-.5h5.3a.5.5 0 1 1 0 1H5.2a.5.5 0 0 1-.5-.5Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=list-ordered.js.map